import React from 'react';

import "./imagestack.css";

export const ImageStack = ({ images, key, className, minHeight=0 }) => {
  var imagesChopped = images.slice(0, 3).reverse();

  const getRotation = idx => ((imagesChopped.length * 5) + 15) - (idx+1) * 15;

  return (
    <div key={key} className={className} style={{ minHeight: `${minHeight}px` }}>
      {imagesChopped.map((img, i) => (
        <div className="image-wrapper">
          <img
            className="image-item"
            src={img}
            alt="bruh"
            style={{ transform: `rotate(${getRotation(i)}deg) translateY(${minHeight/2}px)` }}
          />
        </div>
      ))}  
    </div>
  )
}